import axios from '@/utils/request'
// import queryString from 'query-string'
const urlPrefix = 'map'

// 获取画布管理列表
export function getCanvasList (params) {
  return axios({
    url: urlPrefix + '/canvas',
    method: 'get',
    params: params
  })
}

// 新建画布
export function addCanvas (params) {
  return axios({
    url: urlPrefix + '/canvas',
    method: 'POST',
    data: {}
  })
}

// 复制画布
export function copyCanvas (id) {
  return axios({
    url: urlPrefix + '/canvas/copy/' + id,
    method: 'POST'
  })
}

// 删除画布
export function delCanvas (id) {
  return axios({
    url: urlPrefix + '/canvas/delete/' + id,
    method: 'DELETE'
  })
}

// 获取画布详情
export function getCanvasDetails (id, item) {
  return axios({
    url: urlPrefix + '/canvas/detail/' + id,
    method: 'get'
  }).then(async req => {
    // 打开编辑器前，检查画布名称是否一致，不一致则更新画布数据（复制画布后名称会不一致的问题）
    if (item && item.name !== req.data.jsonForDetail.name) {
      req.data.jsonForDetail.name = item.name
      await saveCanvas(req.data)
      console.log('画布名称不一致已更新数据')
    }
    return req
  })
}

// 保存更新画布
export function saveCanvas (params) {
  return axios({
    url: urlPrefix + '/canvas',
    method: 'PUT',
    data: params
  })
}

// 获取分享列表
export function getShareCanvasList (params) {
  return axios({
    url: urlPrefix + '/canvas/share/page',
    method: 'get',
    params: params
  })
}

// 开启/关闭画布分享
export function enableCanvasShare (params) {
  return axios({
    url: urlPrefix + '/canvas/share/enable',
    method: 'PUT',
    data: params
  })
}

// 获取分享配置
export function getShareCanvasDetails (params) {
  return axios({
    url: urlPrefix + '/canvas/share/noncestr',
    method: 'get',
    params: params
  })
}

// 检查画布是否有效
export function checkShareCanvas (params) {
  return axios({
    url: urlPrefix + '/canvas/share/template/share/check',
    method: 'get',
    params: params
  })
}

/**
 * 获取Api数据源
 */
export async function getDataSourceSchemas () {
  // 获取excel类型的数据表
  const excels = await axios.get('/map/dataSources/list', {
    params: {
      dataSourceType: 'EXCEL'
    }
  }).then(req => {
    return req.data.map(({ id, name, excelData }) => {
      const { properties } = excelData
      return {
        id: id,
        name,
        interval: 999,
        method: 'get',
        alias: properties.map(p => ({ key: `${p.id}`, name: p.name })),
        keys: properties.map(p => `${p.id}`),
        mode: `(p)=> {
          const { excelData } = p.data;
          const temp = excelData.properties.reduce((result, val) => Object.assign(result, { [val.id]: [] }), {});
          const { records } = excelData.data;
          const total = records.length;
          Object.keys(temp).forEach(key => {
            const arr = temp[key];
            for (let i = 0; i < total; i++) {
              arr.push(records[i][key]);
            }
          });
          return temp;
        }`,
        rtype: 'table',
        url: `${process.env.VUE_APP_API_BASE_URL}/map/dataSources?id=${id}&pageNumber=1&pageSize=999999`.replace('//map', '/map'),
        spec: 'excel'
      }
    })
  })
  console.log('xxxxxx', excels)

  const ids = await axios.get('/map/dataSources/list', {
    params: {
      dataSourceType: 'API'
    }
  }).then(req => {
    return req.data.map(p => p.id)
  })
  const d = await axios.get('/map/dataSources/apis', {
    // paramsSerializer: function (params) {
    //   console.log(params, queryString.stringify(params, { arrayFormat: 'separator' }))
    //   return queryString.stringify(params, { arrayFormat: 'separator' })
    // },
    params: { ids: ids.join(',') }
  }).then(req => {
    return req.data.map(item => {
      const { name, id, apiConfig } = item
      return {
        ...apiConfig.config,
        id,
        name
      }
    })
  })
  console.log(excels.concat(d))
  return excels.concat(d)
}
